<template>
  <div class="page hp_center">
    <div class="content hp_flex">
      <div class="left">
        <img style src="@/assets/login/login-left.png" alt />
      </div>
      <div class="right">
        <div class="name hp_cz_center">
          <img style src="@/assets/login/logo.png" alt />
          <div>
            <div class="cn">淮南智慧医疗</div>
            <div class="en">HUAINAN SMART MEDICAL</div>
          </div>
        </div>
        <div>
          <a-form-model
            ref="ruleForm"
            :rules="rules"
            :model="formInline"
            @submit="handleSubmit"
            @submit.native.prevent
          >
            <a-form-model-item prop="mobile">
              <a-input v-model="formInline.mobile" placeholder="请输入手机号码">
                <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25);font-size: 20px;" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="code">
              <div class="code">
                <a-input v-model="formInline.code" placeholder="请输入验证码">
                  <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25);font-size: 20px;" />
                </a-input>
                <a-button
                  :disabled="disabled"
                  @click="getCode"
                  class="btn"
                  type="link"
                  block
                >{{ txt }}</a-button>
              </div>
            </a-form-model-item>
            <a-form-model-item prop="select">
              <a-checkbox @change="onChange">
                <span>勾选同意</span>
                <span style="color:#0C62FF;" @click.stop="openUserAgree">《用户协议》</span>
                <span>和</span>
                <span style="color:#0C62FF;" @click.stop="openPrivacyAgree">《隐私协议》</span>
              </a-checkbox>
            </a-form-model-item>
            <a-form-model-item>
              <a-button class="login" type="primary" html-type="submit">登录/注册</a-button>
            </a-form-model-item>
          </a-form-model>

          <!-- 第三方登录 -->
          <div class="foot_div">
            <p>扫码登录：</p>
            <div>
              <img src="@/assets/payment/wx.png" @click="clickLogin(0)" />
              <img src="@/assets/payment/zfb.png" @click="clickLogin(1)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal :title="null" :closable="false" :footer="null" width="595px" v-model="suerAgree">
      <User-agreement></User-agreement>
    </a-modal>
    <a-modal :title="null" :closable="false" :footer="null" width="750px" v-model="suerPrivacy">
      <Privacy-agreement></Privacy-agreement>
    </a-modal>

    <div v-if="show" class="wxlogin_box" @click="show = !show">
      <div class="wxlogin_img">
        <wxlogin
          class="wx"
          :appid="wx.appid"
          :scope="wx.scope"
          :response_type="wx.response_type"
          :state="wx.state"
          :redirect_uri="wx.redirect_uri"
        ></wxlogin>
      </div>
    </div>
  </div>
</template>
<script>
import { login, getCode, getInfo, getDict, getBaseDepts } from "@/api/user";
import { setToken, getToken } from "@/utils/auth";
import { getRandomAesKey, decrypt, ls } from "@/utils/tool";
import UserAgreement from "@/components/UserAgreement";
import PrivacyAgreement from "@/components/PrivacyAgreement";
import { webWxLink, webZfbLink } from "@/api/user-center";
import wxlogin from "vue-wxlogin";
import qs from "qs";
var count = 60,
  timer = null;
export default {
  components: {
    UserAgreement,
    PrivacyAgreement,
    wxlogin,
  },
  data() {
    let checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号码"));
      }
      let zz = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
      if (!zz.test(value)) {
        callback(new Error("手机号码格式错误"));
      } else {
        callback();
      }
    };
    return {
      disabled: false,
      suerAgree: false,
      suerPrivacy: false,
      txt: "获取验证码",
      formInline: {
        code: "",
        fromType: "5", //5
        mobile: "", //13882029908
        select: "",
      },
      rules: {
        mobile: [
          {
            validator: checkMobile,
            trigger: "blur",
          },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "change" }],
        select: [{ required: true, message: "请勾选", trigger: "blur" }],
      },
      show: false,
      wx: {
        appid: "",
        scope: "",
        redirect_uri: "",
        response_type: "",
        state: "",
      },
    };
  },
  created() {
    this.$route.params;
    if (Object.hasOwnProperty.call(this.$route.params, "message")) {
      this.$message.error(this.$route.params.message);
    }
  },
  mounted() {},
  destroyed() {
    clearInterval(timer);
    count = 60;
    timer = null;
  },
  methods: {
    //微信登录
    async clickLogin(num) {
      if (num == 0) {
        let res = await webWxLink();
        let url = res.data;
        const query = qs.parse(url.substring(url.indexOf("?") + 1));
        this.wx = query;
        // this.wx.redirect_uri = 'https://www.baidu.com'
        console.log(this.wx)
        this.show = true;
        // console.log("微信扫码回调", res);
      } else {
        let res = await webZfbLink();
        // console.log("支付宝扫码回调", res);
        let url = res.data;
        window.open(url, "_self");
      }
    },
    onChange(e) {
      this.formInline.select = e.target.checked;
    },
    async getCode() {
      if (!this.formInline.mobile) {
        this.$message.warning("请输入手机号");
        return;
      }
      if (
        !this.formInline.mobile.length == 11 ||
        !/^(?:(?:\+|00)86)?1\d{10}$/.test(this.formInline.mobile)
      ) {
        this.$message.warning("手机号格式不正确，请输入正确的手机号格式");
        return;
      }
      this.disabled = true;
      var res = await getCode(this.formInline.mobile);
      console.log("getCode=====", res);
      if (res.code !== 200) {
        this.$message.error(res.message);
        this.disabled = false;
        return;
      }
      if (timer == null) {
        timer = setInterval(() => {
          count--;
          this.txt = count + "秒后获取验证码";
          if (count <= 0) {
            this.disabled = false;
            clearInterval(timer);
            this.txt = "获取验证码";
            timer = null;
          }
        }, 1000);
      }
    },
    //登录\注册
    handleSubmit() {
      if (!this.formInline.select) {
        this.formInline.select = null;
      }
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          var res = await login(this.formInline);
          if (res.code != 200) {
            this.formInline.code = "";
            this.$message.error(res.message);
            return;
          }
          setToken(res.data);
          ls.set("token", res.data);
          var key = getRandomAesKey();
          var resUser = await getInfo({ token: res.data, key });
          if (resUser) {
            var data = JSON.parse(
              decrypt(resUser.data, key.slice(0, 16), key.slice(16))
            );
            console.log("user====", data);
            this.getDicts();
            ls.set("sysUser", data);
          }
          this.$router.push("/");
          // window.open("https://www.hnzhyl.net", "_self");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async getDicts() {
      var HOSP_LEVEL = await getDict({ type: "HOSP_LEVEL" });
      var HOSP_TYPE = await getDict({ type: "HOSP_TYPE" });
      var HOSP_ADMIN = await getDict({ type: "HOSP_ADMIN" });
      var baseDepts = await getBaseDepts();
      ls.set("HOSP_LEVEL", HOSP_LEVEL.data);
      ls.set("HOSP_TYPE", HOSP_TYPE.data);
      ls.set("HOSP_ADMIN", HOSP_ADMIN.data);
      ls.set("baseDepts", baseDepts.data);
    },
    openUserAgree() {
      this.suerAgree = true;
    },
    openPrivacyAgree() {
      this.suerPrivacy = true;
    },
  },
};
</script>
<style scoped lang="less">
body {
  width: 100vw;
  height: 100vh;
  background-image: url("~@/assets/login/bg.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.content {
  margin-top: 183px;
  width: 1533px;
  height: 717px;
  background: #ffffff;
  box-shadow: 0px 7px 27px 0px rgba(133, 169, 231, 0.51);
  border-radius: 20px;
  overflow: hidden;
  .left {
    img {
      width: 790px;
      height: 718px;
    }
    margin-right: 80px;
  }
  .right {
    .name {
      margin-top: 41px;
      margin-left: 126px;
      margin-bottom: 46px;
      img {
        width: 85px;
        height: 94px;
        margin-right: 21px;
      }
      div {
        font-family: Source Han Sans SC;
        color: #000000;
        line-height: 1;
        font-weight: 500;
      }
      .cn {
        font-size: 41px;
      }
      .en {
        font-size: 21px;
        margin-top: 9px;
      }
    }
    /deep/.ant-input {
      height: 70px !important;
      font-size: 20px !important;
      text-indent: 15px !important;
    }
    .login {
      width: 553px;
      height: 88px;
      background: linear-gradient(90deg, #6fb2ff, #095fff);
      box-shadow: 0px 7px 27px 0px rgba(50, 129, 255, 0.51);
      border-radius: 2px;
      font-size: 14px;
    }
    .code {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      .btn {
        width: 100px;
      }
    }
  }
}
.wxlogin_box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.5);
  z-index: 100;
  .wxlogin_img {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -200px 0 0 -150px;
    .wx {
      color: #fff;
    }
  }
}
.foot_div {
  display: flex;
  align-items: center;
  p {
    font-size: 16px;
    font-weight: 400;
    margin: 0;
  }
  img {
    width: 50px;
    height: 50px;
    margin-right: 20px;
  }
  div {
    flex: 1;
    margin-left: 10px;
    display: flex;
  }
}
</style>
